/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Filter } from "../../commons/types/Filter";
import { FilterField } from "../../commons/types/FilterField";
import { SearchValue } from "../../commons/types/SearchValue";
import { SearchField } from "../../commons/types/SearchField";
import { RecordId } from "../../commons/types/RecordId";
import { CellValueUnion } from "../../records/types/CellValueUnion";
export const FindAndReplaceJobConfig = core.serialization.object({
    filter: Filter.optional(),
    filterField: FilterField.optional(),
    searchValue: SearchValue.optional(),
    searchField: SearchField.optional(),
    q: core.serialization.string().optional(),
    ids: core.serialization.list(RecordId).optional(),
    find: CellValueUnion.optional(),
    replace: CellValueUnion.optional(),
    fieldKey: core.serialization.string(),
    snapshotLabel: core.serialization.string().optional(),
});
